/**
 * FF AI Agent 模块 - 中文翻译
 * PR1: 三栏壳 + Onboarding empty state
 */
export const agentZh = {
  title: 'FF AI 助手',
  tagline: '项目查询 · 审批提交 · 知识问答 —— 你的工作伙伴',

  context: {
    title: '上下文',
    empty: '开始对话后会显示相关上下文（项目、知识库、审批模板）',
  },

  composer: {
    placeholder: '问点什么，或描述你想做的事…',
    send: '发送',
    stop: '停止',
    cancel: '取消',
    hint: '按 Enter 发送，Shift+Enter 换行',
    disclaimer: 'FF AI 可能出错，重要信息请核实',
  },

  nav: {
    newSession: '新对话',
    history: '历史会话',
    empty: '暂无历史会话',
    groups: {
      today: '今天',
      past7: '过去 7 天',
      past30: '过去 30 天',
      older: '更早',
    },
  },

  msgActions: {
    copy: '复制',
    copied: '已复制',
    retry: '重新生成',
    edit: '编辑',
    resubmit: '保存重发',
  },

  emptyHero: {
    heading: '今天想做什么？',
    chipsHint: '试试这些场景：',
  },

  artifact: {
    title: '工件',
    close: '关闭',
  },

  personas: {
    sectionTitle: '智能体',
    newPersona: '新建智能体',
    namePlaceholder: '智能体名（例：合同审查员）',
    descriptionPlaceholder: '一句话说明',
    instructionsPlaceholder: '它该怎么工作（system prompt）…',
    create: '创建',
    cancel: '取消',
    delete: '删除',
    hide: '隐藏',
    deleteConfirm: '删除「{name}」？',
    hideConfirm: '系统预设无法真删，是否隐藏「{name}」？',
    systemBadge: '预设',
    empty: '还没有智能体',
  },

  memory: {
    sectionTitle: '记忆',
    add: '添加记忆',
    placeholder: '记下一条关于你的事实或偏好（例：习惯用中文、在 EAI 工作）…',
    save: '保存',
    cancel: '取消',
    empty: '还没有记忆。添加后 agent 每次对话自动读取',
    deleteConfirm: '删除这条记忆？',
    delete: '删除',
    hint: '所有会话自动读取',
    categoryLabel: '类别',
    categories: {
      USER: '偏好',
      FEEDBACK: '反馈',
      PROJECT: '项目',
      REFERENCE: '参考',
    },
    sourceAiDetected: 'AI 自动',
    sourceSystem: '组织共享',
  },

  projects: {
    sectionTitle: '项目',
    newProject: '新建项目',
    newProjectPlaceholder: '项目名（例：产品思考）',
    create: '创建',
    cancel: '取消',
    deleteConfirm: '删除项目「{name}」？该项目内的对话会保留，但归属会清空。',
    delete: '删除',
    rename: '重命名',
    unassignedLabel: '未分组对话',
    allLabel: '全部对话',
    empty: '还没有项目，新建一个把相关对话归类',
  },

  askUser: {
    openEndedHint: '在下方输入你的回答继续对话…',
  },

  admin: {
    routing: {
      newRule: '新建规则',
      deleteConfirm: '删除规则「{name}」？此操作不可恢复。',
      tableHeaders: {
        name: '名称',
        actions: '操作',
      },
      empty: {
        rules: '暂无规则',
        decisions: '暂无决策记录',
      },
      form: {
        name: '名称',
        namePlaceholder: '例：translation → qwen-turbo',
        priority: 'priority（越小越优先）',
        scope: 'scope',
        scopeRefId: 'scopeRefId（USER/PROJECT 时填对应 id；ORGANIZATION 留空走当前 org）',
        provider: 'primary.provider',
        model: 'primary.model',
        pattern: 'pattern（JSON，5 信号匹配条件）',
        patternPlaceholder: '例：{"taskType":"translation"}',
        cancel: '取消',
        create: '创建',
      },
    },
    memory: {
      title: '组织共享记忆',
      subtitle: '这里的记忆对本组织全部用户的每次对话自动生效。',
      add: '新增',
      placeholder: '一句话写下组织级别的事实/政策/约束（例：所有金额单位用人民币）...',
      empty: '当前组织还没有共享记忆',
      allCategories: '全部',
    },
  },

  onboarding: {
    heading: '试试这些场景',
    subheading: '点击卡片直接开始',
    cards: {
      projectQuery: {
        title: '查项目进度',
        prompt: '帮我查一下「FF91 量产准备」项目本周关键里程碑',
        tag: '项目查询',
      },
      approvalSubmit: {
        title: '提一个出差申请',
        prompt: '帮我提交一个下周三去上海的出差申请，参加合作伙伴会议',
        tag: '审批提交',
      },
      knowledgeQA: {
        title: '问个制度问题',
        prompt: '公司年假怎么计算？我去年没休完的能转结吗？',
        tag: '知识问答',
      },
    },
  },

  language: {
    label: '语言',
    zh: '中文',
    en: 'English',
  },

  slash: {
    hint: '可用命令：',
    commands: {
      clear: { name: '/clear', description: '关闭当前会话并新建一个' },
      compact: { name: '/compact', description: '让 AI 把对话历史压缩成摘要' },
      help: { name: '/help', description: '查看所有可用命令' },
      plan: { name: '/plan', description: '切换 Plan mode（先列计划再执行）' },
      readonly: { name: '/readonly', description: '切换 READ_ONLY mode（禁用写动作）' },
      normal: { name: '/normal', description: '恢复默认 mode' },
    },
    notFound: '未识别的命令：{cmd}。输入 /help 看可用命令',
    helpHeader: '可用的斜杠命令：',
  },
};
